/* file description */

import { ASSETMODELMAPPing } from '../../components/SPTableWithModel/effect/consts';

const moduleMapAsset = () => {
  const transformAssetFieldType = (type: string) => {
    const assetTypeMap = new Map(ASSETMODELMAPPing);
    return assetTypeMap.get(type);
  };


  return {
    transformAssetFieldType,
  };
};
export default moduleMapAsset;
